/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratEnabler,
    JsonStratEnablerFromJSON,
    JsonStratEnablerFromJSONTyped,
    JsonStratEnablerToJSON,
} from './JsonStratEnabler';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratEnabler
 */
export interface ApiResultOfJsonStratEnabler {
    /**
     * 
     * @type {JsonStratEnabler}
     * @memberof ApiResultOfJsonStratEnabler
     */
    data?: JsonStratEnabler;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratEnabler
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratEnabler
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratEnabler
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratEnabler
     */
    result?: ApiResultOfJsonStratEnablerResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratEnablerResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratEnablerFromJSON(json: any): ApiResultOfJsonStratEnabler {
    return ApiResultOfJsonStratEnablerFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratEnablerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratEnabler {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratEnablerFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratEnablerToJSON(value?: ApiResultOfJsonStratEnabler | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratEnablerToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

